import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useData } from "@/context/DataContext";

const CONSENT_KEY = "av_cookie_consent";

function hasFullConsent() {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY) || "{}").value === "all";
  } catch {
    return false;
  }
}

let gaLoaded = false;
function loadGA(id) {
  if (gaLoaded || !id) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
}

// Loads Google Analytics 4 only after the user accepts all cookies (GDPR).
// The Measurement ID is configured from the admin panel (settings.ga_measurement_id).
export default function Analytics() {
  const { settings } = useData();
  const { pathname } = useLocation();
  const gaId = settings?.ga_measurement_id;

  useEffect(() => {
    if (!gaId) return;
    if (hasFullConsent()) loadGA(gaId);
    const onConsent = () => { if (hasFullConsent()) loadGA(gaId); };
    window.addEventListener("cookie-consent-changed", onConsent);
    return () => window.removeEventListener("cookie-consent-changed", onConsent);
  }, [gaId]);

  useEffect(() => {
    if (gaId && gaLoaded && window.gtag) {
      window.gtag("event", "page_view", { page_path: pathname });
    }
  }, [pathname, gaId]);

  return null;
}
